import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getDashboardIndicators } from '../../services/dashboard'
import { getLogger } from '../../core/debuggers';

const logger = getLogger('Dashboard.slice.js')

const initialState = {
  error: null,
  loading: false,
  dashboard: {},
  status: 'idle',
};

/**
 * Gets indicator for dashboard.
 */
export const onGetDashboardIndicatorsAsync = createAsyncThunk(
  'dashboard/getIndicators',
  async (_, { getState }) => {
  const state = getState()
  const { user } = state.adminAuth

  // Fetch from Supabase RPC
  const data = await getDashboardIndicators({ userId: user.id })

  if (!data) {
    logger.debug('No dashboard data returned', { userId: user.id })
    return {}
  }

  // Dynamically map DB fields to camelCase and remove null/undefined values
  const dashboard = Object.fromEntries(
    Object.entries(data)
      .filter(([_, v]) => v != null)
      .map(([k, v]) => [k.replace(/_([a-z])/g, (_, char) => char.toUpperCase()), v])
  )

  return dashboard
})

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(onGetDashboardIndicatorsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(onGetDashboardIndicatorsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboard = action.payload;
      })
      .addCase(onGetDashboardIndicatorsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default dashboardSlice.reducer;
